import sb from '@/utils/sb';
import { supabaseAuthActions } from '@/utils/store/supabaseAuth';
import { type ActionFunctionArgs, redirect } from 'react-router'

export async function loader({ request }: ActionFunctionArgs) {
  const supabase = sb;

  const { error } = await supabase.auth.signOut()

  if (error) {
    console.error(error)
    return { success: false, error: error.message }
  }

  // 清除认证状态
  supabaseAuthActions.clear();

  // Redirect to dashboard or home page after successful sign-in
  return redirect('/', {  })
}
